import { Pipe, PipeTransform } from '@angular/core';
import { Feature } from '../../classes/auth/feature.class';
import { Functionality } from '../../classes/auth/functionality';

@Pipe({
    name: 'functionalityHasFeature',
    standalone: false,
})
export class FunctionalityHasFeaturePipe implements PipeTransform {
    transform(functionality: Functionality, feature: Feature, ...args: unknown[]): boolean {
        return !!functionality.features?.find(f => f.key === feature.key);
    }
}
